import IPremiumFee, { TitleFeesEnum } from '../classes/IPremiumFee';
import { PolicyTypeEnum } from '../classes/PolicyTypeEnum';

const getListOfPrimaryItems = (policyType: PolicyTypeEnum, premium?: IPremiumFee[] | null): IPremiumFee[] | null => {
  if (premium === null || premium === undefined || premium.length === 0) {
    return null;
  } else {
    let items = premium.filter((item: IPremiumFee) => item.total !== null && item.total !== undefined);
    if (policyType === PolicyTypeEnum.owner) {
      items = premium.filter(
        (item: IPremiumFee) =>
          item.type !== TitleFeesEnum.extended_lenders_policy && item.type !== TitleFeesEnum.lenders_policy
      );
    } else {
      items = premium.filter(
        (item: IPremiumFee) =>
          item.type !== TitleFeesEnum.homeowners_policy && item.type !== TitleFeesEnum.standard_owners_policy
      );
    }
    return items.length === 0 ? null : items;
  }
};

export default getListOfPrimaryItems;
